package learning.components


import antd.button.button
import antd.form.form
import antd.form.formItem
import antd.input.input
import antd.message.message
import com.jingfangpai.common.orm.mapping.enums.ContentType
import com.jingfangpai.content.model.ContentVo
import react.*
import react.dom.div
import external.ckEditor.CKEditor
import external.ckEditor.ClassicEditor
import external.ckEditor.EditorConf
import external.ckEditor.EditorToolbarConf
import kotlinext.js.Object
import kotlinext.js.js
import kotlinext.js.jsObject
import kotlinx.browser.document
import react.dom.attrs
import react.dom.textarea
import react.router.dom.useHistory
import learning.containers.GuidelineEditPageContext

external interface GuidelineEditProps : RProps {
    var id:String
}

data class GuidelineEditContextData(var placeHolderFunction: (param: String) -> Unit)

val GuidelineEdit = functionalComponent<GuidelineEditProps> { props ->

    val ctx = useContext(GuidelineEditPageContext)
    val history = useHistory()
    val (guideline,setGuideline) = useState(ContentVo().apply {
        type = ContentType.Guideline
    })
    val (editor,setEditor) = useState<CKEditor?>(null)
    val (editorContentLoaded,setEditorContentLoaded) = useState(false)

    fun onContentChanged(event:dynamic,data:dynamic,editorInstance:CKEditor){
        setEditor(editorInstance)
    }

    fun onEditorInit(editor:CKEditor){
        console.log("onEditorInit",editor)
        setEditor(editor)

        editor.editing.view.change( {writer->
            writer.setStyle( "min-height", "400px", editor.editing.view.document.getRoot() );
        } );
        editor.model.document.on("change:data", {event,data->
            onContentChanged(event,data,editor)
        });
    }

    fun onSave(event: dynamic) {
        editor?.let {
            editor.getData().let{ data ->
                guideline.content = data
            }
        }
        if(guideline.title.isNullOrBlank()){
            message.error("请填写标题")
            return;
        }
        if(guideline.content.isNullOrBlank()){
            message.error("请详述指引内容")
            return;
        }
        message.loading("正在保存")
        ctx.saveContent(guideline,{ resp->
            if(resp.ok()){
                if(guideline.id.isNullOrBlank()){ //新增
                    history.push(LearningRoute.GuidelineEdit.link.url.replace(":id",resp.data?.id?:""))
                }else {
                    resp.data?.let { setGuideline(it) }
                }
            }
        },{
            console.log(it)
            message.error("保存失败，${it.message}")
        })
    }

    useEffect(guideline) {
        if(editor != null && guideline.content != null && editor.getData().isNullOrBlank() && guideline.content != editor.getData()){ //仅当编辑器内容为空时
            editor.setData(guideline.content!!)
            setEditorContentLoaded(true)
        }
    }

    useEffect(editor){
        console.log("data",editor?.getData())
        if(editor != null && !editorContentLoaded && guideline.content != null && guideline.content != editor.getData()){
            editor.setData(guideline.content!!)
            setEditorContentLoaded(true)
        }
    }

    useEffect(props.id) {
        if("new"!=props.id){
            if(props.id.length == 32) {
                ctx.getContent(ContentType.Guideline,props.id,{ resp->
                    if(resp.ok() && resp.data !=null){
                        setGuideline(resp.data!!)
                    }else{
                        message.error("获取指引失败")
                    }
                },{
                    message.error("获取指引失败")
                })
            }
        }else{

        }
    }
    useEffectOnce {
        ClassicEditor.create(document.querySelector("#editor"), jsObject<EditorConf> {
            toolbar = jsObject <EditorToolbarConf> {
                toolbar = jsObject <EditorToolbarConf> {
                    alignment = kotlinext.js.js {
                        options = arrayOf("left", "right")
                    }
                    items = arrayOf(
                        "heading",
                        "|",
                        "bold",
                        "italic",
                        "underline",
                        "fontSize",
                        "fontColor",
                        "alignment",
                        "strikethrough",
                        "link",
                        "bulletedList",
                        "numberedList",
                        "|",
                        "outdent",
                        "indent",
                        "|",
                        "imageUpload",
                        "blockQuote",
                        "insertTable",
                        "undo",
                        "redo",
                        "horizontalLine",
                        "removeFormat"
                    )
                }
                props.id?.let{ id->
                    simpleUpload = kotlinext.js.js {
                        // The URL that the images are uploaded to.
                        uploadUrl = "/api/file/upload/ckeditor?entityType=Content&entityId=${id}"

                        // Enable the XMLHttpRequest.withCredentials property.
                        withCredentials = false

                        // Headers sent along with the XMLHttpRequest to the upload server.
                        /*headers = js {
                            entityType = "Content"
                            entityId = props.id
                        }*/
                    }
                }
            }
            link = js{
                addTargetToExternalLinks = false
                decorators = js {
                    openInNewTab = js {
                        mode = "manual"
                        label = "Open in a new tab"
                        defaultValue = true         // This option will be selected by default.
                        attributes = js {
                            target = "_blank"
                            rel = "noopener noreferrer"
                        }
                    }
                }
            }
            language = "zh-cn"
            licenseKey = ""
        }
        )
            .then(::onEditorInit)
            .catch { error ->
                console.error(error);
            }

    }

    div("TopicEdit") {
        form {
            attrs{
                layout = "horizontal"
            }
            formItem {
                attrs{
                    label = "标题"
                }
                input {
                    attrs {
                        value = guideline.title ?:""
                        placeholder = "必填"
                        onChange = {event: dynamic ->
                            val _topic = Object.assign(ContentVo(),guideline)
                            _topic.title = event.target.value as String
                            setGuideline(_topic)
                        }
                    }
                }
            }

            formItem {
                attrs{
                    label = "指引详情"
                }
                div{
                    textarea{
                        attrs{
                            rows = "40"
                        }
                        attrs["id"] = "editor"
                    }
                }
            }

            formItem {
                attrs{
                    label = "排序位置"
                }
                input {
                    attrs {
                        type = "number"
                        value = guideline.weight ?:1
                        placeholder = "请填写排序位置"
                        onChange = {event: dynamic ->
                            val _topic = Object.assign(ContentVo(),guideline)
                            _topic.weight = (event.target.value as String).toInt()
                            setGuideline(_topic)
                        }
                    }
                }
            }

            formItem {
                button {
                    attrs{
                        type = "primary"
                        onClick = ::onSave
                    }
                    +"提交"
                }
            }
        }
    }
}
